import { render, staticRenderFns } from "./AttrValueTable.vue?vue&type=template&id=2269fd81"
import script from "./AttrValueTable.vue?vue&type=script&lang=js"
export * from "./AttrValueTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports